var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#138de8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.875 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.592,15H3.658A3.709,3.709,0,0,1,0,11.25V7.11A3.713,3.713,0,0,1,3.658,3.353h.153a3.433,3.433,0,0,1,.98-2.37A3.33,3.33,0,0,1,7.132,0,3.243,3.243,0,0,1,9.458.982a3.42,3.42,0,0,1,.981,2.371h.153A3.713,3.713,0,0,1,14.25,7.11v4.14A3.709,3.709,0,0,1,10.592,15ZM9.9,4.245a.556.556,0,0,0-.549.562v.87a.549.549,0,1,0,1.1,0v-.87A.556.556,0,0,0,9.9,4.245Zm-5.625,0a.563.563,0,0,0-.549.562v.87a.549.549,0,1,0,1.1,0v-.87A.556.556,0,0,0,4.279,4.245Zm2.853-3.12a2.235,2.235,0,0,0-1.573.659,2.319,2.319,0,0,0-.651,1.568H9.341A2.249,2.249,0,0,0,7.132,1.125Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBag);
export default __webpack_public_path__ + "static/media/blueBag.e85cf1349efaa2d9a14704df03af52af.svg";
export { ForwardRef as ReactComponent };